export default __webpack_public_path__ + "static/media/envelope.475d9391.png";